// extracted by mini-css-extract-plugin
module.exports = {"table":"InfoTable_table___tlXd","header":"InfoTable_header__mGMFu","shadedCell":"InfoTable_shadedCell__UjdsW"};